//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const lg = '(min-width: 1024px)'
const md = '(max-width: 1023.99px) and (min-width: 501px)'
const sm = '(max-width: 500.99px)'

export default {
  name: 'HowItWorks',
  data () {
    return {
      isPC: typeof window !== 'undefined' ? window.matchMedia(lg).matches : false,
      isTablet: typeof window !== 'undefined' ? window.matchMedia(md).matches : false,
      isMobile: typeof window !== 'undefined' ? window.matchMedia(sm).matches : false,
      // swiperOptions: {
      //   pagination: {
      //     el: '.swiper-pagination'
      //   },
      //   width: this.isPC ? 836 : 636,
      //   slidesPerView: 2,
      //   centeredSlides: true,
      //   paginationClickable: true,
      //   spaceBetween: 24,
      //   nextButton: '.swiper-next',
      //   prevButton: '.swiper-prev',
      //   slidesOffsetBefore: -100
      //   // grabCursor: true,
      //   // slideToClickedSlide: true
      //   // loop: true
      //   // autoplay: {
      //   //   delay: 10000,
      //   //   stopOnLastSlide: false,
      //   //   disableOnInteraction: true
      //   // }
      // },
      worksList: [
        {
          img: require('@/assets/img/pagsmile-card/works/image0.png'),
          title: 'Quick Sign Up',
          description: 'Register with Pagsmile by providing basic information.'
        },
        {
          img: require('@/assets/img/pagsmile-card/works/image1.png'),
          title: 'Get Instant Access',
          description: 'Generate your virtual card and start using it immediately.'
        },
        {
          img: require('@/assets/img/pagsmile-card/works/image2.png'),
          title: 'Integrate Seamlessly',
          description: 'Sync with SmileOne and LinkMe for a unified experience.'
        },
        {
          img: require('@/assets/img/pagsmile-card/works/image3.png'),
          title: 'Monitor and Manage',
          description: 'Use the dashboard to track and manage your expenses easily.'
        }
      ]
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    swiperOptions () {
      return {
        pagination: {
          el: '.swiper-pagination'
        },
        width: this.isPC ? 1496 : 636,
        slidesPerView: this.isPC ? 4 : 2,
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 24,
        nextButton: '.swiper-next',
        prevButton: '.swiper-prev',
        slidesOffsetBefore: this.isPC ? 0 : -100
      }
    }
  },
  mounted () {
    // console.log('Current Swiper instance object', this.swiper)
    if (this.isPC) {
      this.swiper.slideTo(1, 1000, false)
    } else {
      this.swiper.slideTo(0, 1000, false)
    }
  }
}
